<!-- 单个探头 -->
<template>
  <div
    class="echartPage"
    :class="{ 'padding-remove': $route.name !== 'probeHistory' }"
  >
    <div class="headerClass" v-if="$route.name === 'probeHistory'">
      {{ query.deviceName }}
    </div>
    <div class="contentClass">
      <v-search
        :formContent="formContent"
        :SearchForm="SearchForm"
        @resetFn="resetFn"
        @searchFn="searchFn"
        :inline="true"
        :optareBtn="optareBtn"
      />
      <!-- tab -->
      <EchartTab @unitChange="unitChange" @downLoad="downLoad" :tabs="tabs" />
      <div v-show="echartObj.data.length" class="w-100">
        <!-- 信息 -->
        <FullPath
          v-if="$route.name === 'probeHistory'"
          @onFullPath="onFullPath"
        ></FullPath>
        <!-- <InfoMsg :listObj="listObj" /> -->
        <!-- 图表 -->
        <EchartContent
          ref="chart"
          :echartObj="echartObj"
          :loading="isRenderChart"
          :unitObj="unitObj"
          :options="chartOptions"
        />
        <!-- 最值 -->
        <MaxMin :listObj="listObj" :unitObj="unitObj" />
        <el-table
          :data="tableData"
          stripe
          v-loading="loading"
          ref="multipleTable"
          tooltip-effect="dark"
          style="width: 100%"
          :header-cell-style="headCellStyle"
          :height="
            $route.name === 'probeHistory'
              ? 'calc(100% - 600px)'
              : 'calc(100% - 530px)'
          "
          :row-style="{ height: '35px' }"
        >
          <el-table-column :label="$t('integration.equipment')" prop="no">
            <template #default="{ row }">
              <AsyncPopover
                trigger="hover"
                :cache-key="['appConfig', 'sensor_no']"
                :request="async () => getProbeDetailRequest(row)"
                :key="row.collectTime"
              >
                <template #default="{data,loading}">
                  <div v-loading="loading">
                    <ul>
                      <li>
                        {{ $t('设备编号') }}:{{
                          data.sensor && data.sensor.tagId
                        }}
                      </li>
                      <li>
                        {{ $t('设备名称') }}:{{
                          data.sensor && data.sensor.tagId
                        }}
                      </li>
                      <template
                        v-for="(value, key) in transformCollectInterval(
                          data.appConfig
                        )"
                      >
                        <li :key="key">{{ key }}:{{ value }}</li>
                      </template>
                      <li>
                        {{ $t('描述') }}:{{
                          data.sensor && data.sensor.description
                        }}
                      </li>
                    </ul>
                  </div>
                </template>

                <template #reference>
                  <i class="el-icon-info cursor-pointer"></i>
                </template>
              </AsyncPopover>
              <!--              <i v-icon:theme="['sensorTypeConvert', query.deviceType]"></i>-->
              {{ row.no }}
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('integration.acquisition_time')"
            prop="collectTime"
          >
            <template #default="{ row }">
              {{ $timetransition(row.collectTime) }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('integration.collect_data')" prop="val">
            <template #default="{ row }">
              <span v-range="[row.val, row]">
                {{ formatTempValue(row.val) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('integration.monitoring_interval')"
            prop="min"
          >
            <template #default="{ row }">
              <template v-if="row.min !== undefined">
                {{ formatTempValue(row.min) }}  ~ {{ formatTempValue(row.max)
                }}
              </template>
              <template v-else>
                {{ $t('integration.no_monitoring_interval') }}
              </template>
            </template>
          </el-table-column>
        </el-table>

        <!--                <Pagination class="pagination" :total="total" :page.sync="SearchForm.iDisplayStart"-->
        <!--                    :limit.sync="SearchForm.iDisplayLength" :pageSizes="[5, 20, 50, 100]"-->
        <!--                    :iDisplayLength="SearchForm.iDisplayLength" @pagination="getListFn('async')">-->
        <!--                </Pagination>-->
        <Pager
          ref="pagination"
          :total="total"
          :size="SearchForm.iDisplayLength"
          @currentChange="currentChange"
        ></Pager>
      </div>
      <div v-show="!echartObj.data.length">
        <el-empty></el-empty>
      </div>
    </div>
    <ExportDialog
      :isShow.sync="exportDiaShow"
      :searchForm="eForm"
      ref="dia"
      :comNmae="exportProbeHistory"
    />
  </div>
</template>

<script>
import { exportProbeHistory, probeHisotry } from '@/api/modules/carrier.js'
import EchartTab from '@/pages/equipment/sensor/echart/EchartTab.vue'
import store from '@/store'
import ExportDialog from '@/pages/count/component/exportDialog.vue'
import FullPath from '@/pages/business/win/ProbeHistory/components/FullPath'
import MaxMin from '@/pages/equipment/sensor/echart/MaxMin.vue'
import EchartContent from '@/pages/equipment/sensor/echart/EchartContent.vue'
import formContent from './config/search'
import { isTimeExceedThreshold } from '@/utils/time'
import { downloadImage } from '@/utils/file/download'
import Pager from '@/components/Pagination/src/Pager.vue'
import chartOptions from '@/config/chart/chartOptions'
import AsyncPopover from '@/components/AsyncPopover/AsyncPopover.vue'
import { getSensorDetail } from '@/api/modules/sensor'
import { transformCollectInterval } from '@/utils/transform/sensorTransForm'
import { TempUtils } from '@/utils/TempUtil.js';

export default {
  props: {
    code: {},
    deviceType: {},
    deviceName: {},
    description: {}
  },
  watch: {
    code: {
      handler () {
        this.SearchForm.code = this.code
        this.resetFn()
      },
      immediate: true
    }
  },
  components: {
    AsyncPopover,
    Pager,
    EchartTab,
    EchartContent,
    MaxMin,
    ExportDialog,
    FullPath
  },
  computed: {
    query () {
      return this.$route.query
    },
    // 是否为温度计
    isTempSensor () {
      const type = parseInt(this.deviceType || this.query.deviceType)

      return type === 1 || type === 3 || type === 5 || type === 7 || type === 9
    },
    // 获取当前单位，增加安全兜底
    currentUnit() {
      return this.unitObj?.unit || '°C'
    }
  },
  data () {
    return {
      // 设备信息缓存  { deviceName:info }
      deviceInfoCache: {},
      chartOptions: chartOptions(),
      isRenderChart: false,
      timeoutFlag: 0,
      loading: false,
      formContent: formContent,
      optareBtn: [],
      tableData: [],
      tabs: ['temp', 'hum'],
      data: [],
      total: 0,
      SearchForm: {
        code: '',
        carrierId: 0,
        time: '',
        isEx: '',
        isStore: '',
        dataSort: 0,
        pageSort: 1,
        devCatalog: 0,
        block: 1,
        probe: 'temp',
        token: null,
        iDisplayStart: 0,
        iDisplayLength: 5,
        from: undefined,
        to: undefined
      },
      listObj: {},
      // echart 数据  必须分离 否则 造成页面渲染缓慢以及卡顿
      echartObj: {
        min: '',
        max: '',
        data: [],
        rangeData: []
      },

      // 温度
      unitArray: [
        {
          key: 'temp',
          unit: "store.state.unit['temp'].name",
          yText: $t('integration.temperature')+`(${"store.state.unit['temp'].name"})`
        },
        {
          key: 'hum',
          unit: "store.state.unit['hum'].name",
          yText: $t('integration.humidity')+`(${"store.state.unit['hum'].name"})`
        }
      ],
      unitObj: {},
      exportDiaShow: false,
      eForm: {},
      exportProbeHistory
    }
  },
  methods: {
    transformCollectInterval,
    formatTempValue(val) {
      if (val === null || val === undefined || val === '') return '--'
      const numVal = Number(val)
      if (isNaN(numVal)) return '--'

      const result = TempUtils.convertToCelsius(numVal, this.currentUnit)
      const finalVal = isNaN(result) ? '--' : Number(result).toFixed(2)
      return `${finalVal}${this.currentUnit}`
    },
    currentChange ({ iDisplayStart, iDisplayLength }) {
      this.SearchForm.iDisplayStart = iDisplayStart
      this.SearchForm.iDisplayLength = iDisplayLength
      this.getListFn()
    },
    downLoad () {
      const { carrierName } = this.query
      const { time } = this.SearchForm
      const base64 = this.$refs.chart.getChart()
      downloadImage(
        base64,
        `[${carrierName}]_[${this.deviceName}]_${$t('integration.carrier_historical_line_chart')}_F[${time[0]}]_T[${time[1]}]`
      )
    },
    resetFn () {
      this.isRenderChart = true
      this.SearchForm.time = ''
      this.SearchForm.isEx = ''
      this.SearchForm.from = ''
      this.SearchForm.to = ''
      this.SearchForm.isStore = ''
      this.SearchForm.iDisplayStart = 0
      this.SearchForm.iDisplayLength = 5
      this.SearchForm.token = ''
      if (this.$refs.pagination) {
        this.$refs.pagination.reset()
      }

      this.getListFn('sync')
    },
    /**
     * 计算两个时间是否大于一个月
     * @param {String} starDate 进行比较的开始日期 时间戳 毫秒
     * @param {String} endDate 进行比较的结束日期  时间戳 毫秒
     * @returns {Boolean}
     */
    getD (starDate, endDate) {
      // 默认90天
      var thisMothDays = 1000 * 3600 * 24 * 90
      if (endDate - starDate > thisMothDays) {
        return true
      } else {
        return false
      }
    },
    searchFn () {
      this.SearchForm.token = ''
      this.isRenderChart = true
      this.SearchForm.iDisplayStart = 0
      this.$refs.pagination.reset()
      this.getListFn('search')
    },
    unitChange (name) {
      this.unitArray.forEach(item => {
        if (name === item.key) {
          this.unitObj = item
        }
      })
      this.SearchForm.probe = name
      this.SearchForm.token = ''

      // this.token = null;
      this.count = 0
      this.getListFn('search')
      this.isRenderChart = true
    },
    updateUnit () {
      this.unitArray[0] = {
        key: 'temp',
        unit: store.state.unit.temp.name,
        yText: $t('integration.temperature')+`(${store.state.unit.temp.name})`
      }
      this.unitArray[1] = {
        key: 'hum',
        unit: store.state.unit.hum.name,
        yText: $t('integration.humidity')+`(${store.state.unit.hum.name})`
      }
      if (!Object.keys(this.unitObj).length) {
        this.unitObj = this.unitArray[0]
      }
    },
    getListFn () {
      this.loading = true
      clearTimeout(this.timeoutFlag)
      if (this.SearchForm.time) {
        this.SearchForm.from = new Date(this.SearchForm.time[0]).getTime()
        this.SearchForm.to = new Date(this.SearchForm.time[1]).getTime()
      }

      if (isTimeExceedThreshold(this.SearchForm.from, this.SearchForm.to)) {
        this.SearchForm.block = 0
      } else {
        this.SearchForm.block = 1
      }
      // delete this.SearchForm.time;
      probeHisotry(this.SearchForm).then(({ result }) => {
        // 没有结束 继续轮询
        if (!result.ok) {
          this.SearchForm.token = result.token
          this.timeoutFlag = setTimeout(() => {
            this.getListFn()
          }, 1000)
          return
        } else {
          if (result.token) {
            this.SearchForm.token = result.token
          }
          this.loading = false
        }

        // 第一页的时候才渲染echart
        if (this.isRenderChart) {
          this.isRenderChart = false
          console.log('probe:进入渲染流程')
          this.echartObj = {
            max: result.max,
            min: result.min,
            data: result.data,
            rangeData: result.rangeData || []
          }
        }
        const { pageInfo, result: pageResult } = result.page
        this.tableData = pageResult
        this.total = pageInfo.total
        this.listObj = result
        if (result.dafaultForm) {
          this.SearchForm.from = result.dafaultForm
          this.SearchForm.to = result.dafaultTo
          this.SearchForm.time = [
            this.$timetransition(result.dafaultForm),
            this.$timetransition(result.dafaultTo)
          ]
        }
      })
    },

    onFullPath (fullPath) {
      document.title =
        fullPath + ' ' + this.$route.query.deviceName + $t('integration.chart')
    },
    async getProbeDetailRequest (row) {
      const { result } = await getSensorDetail(row.no)
      return {
        data: result
      }
    }
  },
  mounted () {
    const { deviceCode, carrierId } = this.$route.query
    this.SearchForm.code = deviceCode || this.code
    // getSensorDetail(this.SearchForm.code).then(res => {
    //   console.log(res)
    // })
    this.SearchForm.carrierId = carrierId
    // 是温度计的话移除湿度
    if (this.isTempSensor) {
      this.tabs.splice(1, 1)
    }
    this.updateUnit()
    this.chartOptions.title.subtext = this.description
  }
}
</script>

<style lang="scss" scoped>
.echartPage {
  padding-top: 0;
  padding: 10px;
  box-sizing: border-box;
  height: 100%;

  .headerClass {
    height: 40px;
    width: 100%;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    border-bottom: 1px solid #CCCCCC;
    box-sizing: border-box;
    // margin-bottom: 15px;
  }

  .contentClass {
    width: 100%;
    height: calc(100% - 55px);
  }

  ::v-deep .el-tabs__header {
    margin-bottom: 10px;
  }

  .pagination {
    padding-top: 0;
    padding-right: 15px !important;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}

.padding-remove {
  padding: 0;
}

</style>
